<template>
  <el-dialog
    title="出库详情"
    :visible.sync="visible"
    width="900px"
    @close="$emit('update:show', false)"
  >
    <el-table :data="item.pdc_out_record_lists">
      <el-table-column
        label="供应方"
        align="center"
        prop="pdc_in_record.supplier"
      ></el-table-column>
      <el-table-column align="center" label="新 / 旧">
        <template slot-scope="scope">
          <template v-if="scope.row.pdc_in_record">
            {{ scope.row.pdc_in_record.category == 1 ? '新齿' : '旧齿' }}
          </template>
        </template>
      </el-table-column>
      <el-table-column
        label="出货批次"
        align="center"
        prop="pdc_in_record.arrive_batch"
      ></el-table-column>
      <el-table-column
        label="出货数量"
        align="center"
        prop="number"
      ></el-table-column>
      <el-table-column label="出库时间" align="center">
        <template slot-scope="scope">
          {{ $time(scope.row.created_at).format('YYYY-MM-DD') }}
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { pdcOutRecordDetail } from '@/service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (this.visible) {
        if (this.model.id) {
          this.getItemInfo(this.model.id)
        }
      }
    },
  },
  data() {
    return {
      item: {},
      visible: this.show,
    }
  },
  methods: {
    async getItemInfo(id) {
      let res = await pdcOutRecordDetail(id)
      if (res.status == 0) {
        this.item = res.data
      }
    },
  },
}
</script>